export enum TimepickerMinutesIterationsType {
    EVERY_5_MINUTES = 'EVERY_5_MINUTES',
    EVERY_10_MINUTES = 'EVERY_10_MINUTES',
    EVERY_15_MINUTES = 'EVERY_15_MINUTES',
}